import { useEffect, useState } from 'react';

/*
 * The landing hero's picture, moving. The still photo is always there; a short
 * loop made from that same photo plays over it on wide screens only, never on
 * a phone or a data-saver connection, and never under prefers-reduced-motion.
 * If the clip is missing or fails, the photo simply stays.
 */
export function HeroMedia({ src, alt, video }: { src: string; alt: string; video?: string }) {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (!video || typeof window === 'undefined') return;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const saveData = (navigator as Navigator & { connection?: { saveData?: boolean } }).connection?.saveData;
    setOk(!reduced && !saveData && window.innerWidth >= 900);
  }, [video]);
  return (
    <div className="lp-hero-media">
      <img src={src} alt={alt} />
      {ok && video && (
        <video className="lp-hero-video" src={video} poster={src} autoPlay muted loop playsInline preload="metadata"
          aria-hidden onError={() => setOk(false)} />
      )}
    </div>
  );
}
